/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Atl_One_LinerInputs */

const en_exp_atl_one_liner = /** @type {(inputs: Exp_Atl_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much training stress you have accumulated over the past ~week.`)
};

const de_exp_atl_one_liner = /** @type {(inputs: Exp_Atl_One_LinerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel Trainingsbelastung du in der letzten ~Woche angesammelt hast.`)
};

/**
* | output |
* | --- |
* | "How much training stress you have accumulated over the past ~week." |
*
* @param {Exp_Atl_One_LinerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_atl_one_liner = /** @type {((inputs?: Exp_Atl_One_LinerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Atl_One_LinerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_atl_one_liner(inputs)
	return de_exp_atl_one_liner(inputs)
});